module.exports = __webpack_public_path__ + "img/symbol_2.352bf3ab.png";